import { ToolOrder } from '@bechtel/ht-types';

import { map } from 'lodash';

export const mapToolOrderCatalogItems = (toolOrder?: ToolOrder) => {
  return toolOrder
    ? map(toolOrder.toolOrderCatalogs, (toolOrderCatalog) => {
        return {
          toolCatalog: toolOrderCatalog.toolCatalog || undefined,
          quantity: toolOrderCatalog.quantity,
          id: toolOrderCatalog.id,
          nonCatalogDescription: toolOrderCatalog.nonCatalogDescription,
          nonCatalogReferenceUrl: toolOrderCatalog.nonCatalogReferenceUrl,
          similarToolCatalog: toolOrderCatalog.similarToolCatalog || undefined,
          nonCatalogUomId: toolOrderCatalog.nonCatalogUomId,
        };
      })
    : [];
};
